export enum SegmentoJusticaEnum {
  SUPREMO_TRIBUNAL_FEDERAL= 'Supremo Tribunal Federal',
  CONSELHO_NACIONAL_JUSTICA = 'Conselho Nacional de Justiça',
  SUPERIOR_TRIBUNAL_JUSTICA = 'Superior Tribunal de Justiça',
  JUSTICA_FEDERAL = 'Justiça Federal',
  JUSTICA_TRABALHO = 'Justiça do Trabalho',
  JUSTICA_ELEITORAL = 'Justiça Eleitoral',
  JUSTICA_MILITAR_UNIAO = 'Justiça Militar da União',
  JUSTICA_ESTADUAL = 'Justiça Estadual',
  JUSTICA_MILITAR_ESTADUAL = 'Justiça Militar Estadual'
}
